module.exports = __webpack_public_path__ + "static/media/DF_Logo_Large.b5dae245.png";